import base from 'hu-postal-codes/postal-codes.json'
import budapest from 'hu-postal-codes/budapest.json'
import szeged from 'hu-postal-codes/szeged.json'
import miskolc from 'hu-postal-codes/miskolc.json'
import debrecen from 'hu-postal-codes/debrecen.json'
import pecs from 'hu-postal-codes/pecs.json'
import gyor from 'hu-postal-codes/gyor.json'

const addCityName = (entries: any[], cityName: string) =>
  entries.map(({ zip }) => ({ zip, city: cityName }))

export const mergedPostalCodes = [
  ...base,
  ...addCityName(budapest, 'Budapest'),
  ...addCityName(debrecen, 'Debrecen'),
  ...addCityName(gyor, 'Győr'),
  ...addCityName(miskolc, 'Miskolc'),
  ...addCityName(pecs, 'Pécs'),
  ...addCityName(szeged, 'Szeged'),
]

export const getCityFromHungarianPostalCode = (zipCode: string): string => {
  const match = mergedPostalCodes.find(
    (entry) => entry.zip.toString() === zipCode
  )
  return match?.city ?? ''
}

export const isValidHungarianPostalCode = (zipCode: string): boolean => {
  const match = mergedPostalCodes.find(
    (entry) => entry.zip.toString() === zipCode
  )
  return !!match
}
